/**
 * @generated SignedSource<<6cb612d4cea5ce160c6eb286adf1c433>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c

import type { ConcreteRequest } from 'relay-runtime';
export type useFeedFollowFeedFollowMutation$variables = {
  follow?: ReadonlyArray<string | null | undefined> | null | undefined;
  unfollow?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useFeedFollowFeedFollowMutation$data = {
  readonly setFeedUserConfig: {
    readonly success: boolean;
  } | null | undefined;
};
export type useFeedFollowFeedFollowMutation = {
  response: useFeedFollowFeedFollowMutation$data;
  variables: useFeedFollowFeedFollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "follow"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unfollow"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "followUsers",
            "variableName": "follow"
          },
          {
            "kind": "Variable",
            "name": "unfollowUsers",
            "variableName": "unfollow"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SetFeedUserConfigPayload",
    "kind": "LinkedField",
    "name": "setFeedUserConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFeedFollowFeedFollowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeedFollowFeedFollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
    "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
    "metadata": {},
    "name": "useFeedFollowFeedFollowMutation",
    "operationKind": "mutation",
    "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
  }
};
})();

(node as any).hash = "7ecf9b28db7400fffab67e3a3c52027c";

export default node;
